import { Component, OnInit } from '@angular/core';
import {DynamicDialogRef} from 'primeng/api';
import {DynamicDialogConfig} from 'primeng/api';
import { MembershipService } from '../../services/membership.service';
import {TreeNode} from 'primeng/api';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-purchasehistory',
  templateUrl: './purchasehistory.component.html',
  styleUrls: ['./purchasehistory.component.css']
})
export class PurchasehistoryComponent implements OnInit {

  purchaseHistoryData: any = [];
  membershipNbr: string;
  autitMembershipColumns:any= [];
  showLoading:boolean = false;
  requestData: any =  {};
  files: TreeNode[];
  duplicateList:any= [];
  filterDates: any = [];
  currentDate: any;
  yearRange: any;
  displayDates: any = {};


  constructor(private membershipService: MembershipService, private datePipe: DatePipe, 
    public ref: DynamicDialogRef, public config: DynamicDialogConfig) {
      this.membershipNbr = this.config.data.membershipNbr;
     }

  ngOnInit() {
    
    this.autitMembershipColumns = [
   { field: 'visitNbr', header: 'Visit Nbr' },
   { field: 'visitDate', header: 'Visit Date' },
   { field: 'visitNbr', header: 'Visit Time' },
   { field: 'visitNbr', header: 'Store Nbr' },
   { field: 'visitNbr', header: 'Transaction Nbr' },
   { field: 'visitNbr', header: 'Cardholder Nbr' },
   { field: 'visitNbr', header: 'Visit Amt' },
   { field: 'visitNbr', header: 'Total Tax Amt' }
   // { field: 'visitDate', header: 'Time' },
    //  { field: 'commentText', header: 'Comments' }
   ];
   this.showLoading = true;
   const curDate = new Date();
  this.displayDates.endDate = new Date;
  this.displayDates.startDate = new Date(curDate.setFullYear(curDate.getFullYear() - 1));
  this.requestData.endDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
  this.requestData.startDate = this.datePipe.transform(this.displayDates.startDate , 'yyyy-MM-dd');
    this.requestData.membershipNbr = this.membershipNbr;
    this.currentDate = new Date();
    let temp = new Date();
    let temp2 = new Date(temp.setFullYear(temp.getFullYear() - 10));
    this.filterDates = [this.displayDates.startDate, this.displayDates.endDate];
    this.yearRange = temp2.getFullYear() + ':' + this.currentDate.getFullYear();
    this.purchaseHistoryData = [];
    
    this.membershipService.getPurchaseHistory(this.requestData).subscribe((res: any) => {  
      this.showLoading = false;    
      if (res.code == "SUCCESS") {
        for (var index = 0; index < res.response.length; index++) {
         
          if (!this.duplicateList.includes(res.response[index].visitNbr)) {
            this.duplicateList.push(res.response[index].visitNbr);
            this.purchaseHistoryData.push(res.response[index]);
          }
        }
        
      } 
    });
  }

  fetchPH() {
    if(this.filterDates.length == 2){
      this.requestData.startDate = this.datePipe.transform(new Date(this.filterDates[0]), 'yyyy-MM-dd');
    this.requestData.endDate =  this.datePipe.transform(new Date(this.filterDates[1]), 'yyyy-MM-dd');
    this.requestData.membershipNbr = this.membershipNbr;
      this.membershipService.getPurchaseHistory(this.requestData).subscribe((res: any) => {  
        this.showLoading = false;    
        if (res.code == "SUCCESS") {
          for (var index = 0; index < res.response.length; index++) {
           
            if (!this.duplicateList.includes(res.response[index].visitNbr)) {
              this.duplicateList.push(res.response[index].visitNbr);
              this.purchaseHistoryData.push(res.response[index]);
            }
          }
          
        } 
      });
    }
  }
}
